import { render, staticRenderFns } from "./ThSort.vue?vue&type=template&id=a3b196ec&"
import script from "./ThSort.vue?vue&type=script&lang=ts&"
export * from "./ThSort.vue?vue&type=script&lang=ts&"
import style0 from "./ThSort.vue?vue&type=style&index=0&id=a3b196ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports